// extracted by mini-css-extract-plugin
export var body = "_2g-8";
export var button = "_2g-0";
export var closeButton = "_2g-5";
export var content = "_2g-3";
export var empty = "_2g-f";
export var grid = "_2g-c";
export var header = "_2g-4";
export var icon = "_2g-1";
export var option = "_2g-d";
export var optionSelected = "_2g-e";
export var overlay = "_2g-2";
export var searchIcon = "_2g-a";
export var searchInput = "_2g-b";
export var searchWrapper = "_2g-9";
export var title = "_2g-6";
export var visuallyHidden = "_2g-7";